import { useId } from "react";

export function Input({
  type = "text",
  placeholder = "",
  value = "",
  onChange = () => {},
  pattern,
  title,
  floating = true,
  required = true,
  disabled = false,
  hidden = false,
  min,
  max,
  list = "",
  helpText = "",
  autoFocus = false,
}) {
  const id = useId();

  if (hidden) {
    return null;
  }

  return (
    <div className="form-group">
      <div className={floating ? "form-floating" : ""}>
        {!floating && (
          <label className="form-label" htmlFor={id}>
            {placeholder}
          </label>
        )}

        <input
          id={id}
          className="form-control"
          type={type}
          placeholder={floating ? placeholder : ""}
          value={value}
          onChange={onChange}
          pattern={pattern}
          title={title}
          required={required}
          min={min}
          max={max}
          list={list}
          disabled={disabled}
          autoFocus={autoFocus}
        />

        {floating && (
          <label className="form-label" htmlFor={id}>
            {placeholder}
          </label>
        )}
      </div>

      <small className="form-text text-muted">{helpText}</small>
    </div>
  );
}
